/* global axios */
import ApiClient from './ApiClient';

class ClosureAPI extends ApiClient {
  constructor() {
    super('closure_setting', { accountScoped: true });
  }

  // Configuración de cierres (admin)
  getSettings() {
    return axios.get(this.url);
  }

  updateSettings(data) {
    return axios.patch(this.url, { closure_setting: data });
  }

  // Cierre de una conversación puntual (devuelve el is_latest)
  getConversationClosure(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/closure`
    );
  }

  // SICARG MOD 3 v8 — payload separado: closure (tipificación) + payment_agreement (opcional).
  createConversationClosure(conversationId, closureData, paymentAgreement = null) {
    const body = { conversation_closure: closureData };
    if (paymentAgreement) body.payment_agreement = paymentAgreement;
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/closure`,
      body
    );
  }

  // SICARG — Último motivo de cierre de un contacto (ficha del contacto). 204 si no tiene cierres.
  getContactLastClosure(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/last_closure`);
  }

  // SICARG — Pagos y compromisos del mes vigente de un contacto (control de doble carga).
  getContactMonthPayments(contactId) {
    return axios.get(`${this.baseUrl()}/payment_closures`, {
      params: { contact_id: contactId },
    });
  }

  // SICARG — Elimina un registro de pago/compromiso anterior ("Sobrescribir").
  deletePaymentClosure(id, conversationId) {
    return axios.delete(`${this.baseUrl()}/payment_closures/${id}`, {
      params: { conversation_id: conversationId },
    });
  }

  // SICARG MOD 3 v4 — Reabre una conversación resuelta.
  reopenConversation(conversationId) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/closure/reopen`
    );
  }

  // SICARG MOD 3 v7 — Viaje del cliente: historial completo de cierres de una conversación.
  getConversationHistory(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/closure/history`
    );
  }

  // Estadísticas y listado (admin)
  getStatistics(params = {}) {
    return axios.get(`${this.baseUrl()}/conversation_closures/statistics`, { params });
  }

  listClosures(params = {}) {
    return axios.get(`${this.baseUrl()}/conversation_closures`, { params });
  }

  // SICARG MOD 3 v8 — Forecast: cuotas + pagos únicos, agrupados por mes/semana.
  getProjection(params = {}) {
    return axios.get(`${this.baseUrl()}/conversation_closures/projection`, { params });
  }

  // SICARG MOD 3 v8 — Listado de acuerdos de pago (consumible por Nexus).
  listPaymentAgreements(params = {}) {
    return axios.get(`${this.baseUrl()}/payment_agreements`, { params });
  }

  getPaymentAgreement(id) {
    return axios.get(`${this.baseUrl()}/payment_agreements/${id}`);
  }

  // SICARG MOD 3 v9 — Actualiza el estado de una cuota (pagada / cancelada).
  updateInstallmentEstado(installmentId, estado) {
    return axios.patch(`${this.baseUrl()}/payment_installments/${installmentId}`, { estado });
  }
}

export default new ClosureAPI();
